export const BUSINESS_BILL_PAY_WORKFLOW_CONTAINER_TAG_NAME = 'business-bill-pay-workflow-container';
